import "../css/header.scss";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "../Component/CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="header">
      {/* Top Announcement Bar */}
      <div className="announcement-bar">
        <div className="announcement-left">New Arrivals | Music</div>
        <div className="announcement-right">SHOP NEW ARRIVALS</div>
      </div>

      {/* Main Navigation */}
      <nav className="main-nav">
        <div className="nav-left">
          <Link to="/shop" onClick={toTop}>
            NEW
          </Link>
          <Link to="/about" onClick={toTop}>
            ABOUT
          </Link>
          <Link to="/contact" onClick={toTop}>
            CONTACT
          </Link>
        </div>

        <div className="nav-center">
          <Link to="/" onClick={toTop} className="logo">
            Bernicemy
            <div className="logo-underline"></div>
          </Link>
        </div>

        <div className="nav-right">
          <Link to="/cartpage" onClick={toTop}>
            CART <span className="cart-count">{cartItems.length}</span>
          </Link>
        </div>
      </nav>
    </header>
  );
}

export default Header;
